import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { exportToCSV } from "../../../utils/exportCsv";
import { ALERT, SET_STUDENTS } from "../actionTypes";

export const addStudent = (data) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("centerToken");
    const response = await dispatch(
      postDataAPI("center/student/create", data, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { success: "Student add successfully" } });
    if (response) {
      return response.data.data;
    }
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { error: error.response.message } });
    if (error.response?.data?.message == "Validation errors") {
      Object.entries(error.response.data.data).map((d) => {
        dispatch({
          type: ALERT,
          payload: { error: d[1][0] },
        });
      });
    }
    return false;
  }
};

/**
 * The council registering a student for a center it picks on the form.
 *
 * The center's own version reads the center off its login; the council has no
 * center behind it, so the chosen one travels in the body as center_id.
 */
export const addStudentByAdmin = (data) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const response = await dispatch(
      postDataAPI("admin/student/create", data, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { success: "Student add successfully" } });
    if (response) {
      return response.data.data;
    }
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    if (error.response?.data?.message == "Validation errors") {
      Object.entries(error.response.data.data).map((d) => {
        dispatch({
          type: ALERT,
          payload: { error: d[1][0] },
        });
      });
    } else {
      dispatch({
        type: ALERT,
        payload: {
          error:
            error.response?.data?.message || "The student could not be added.",
        },
      });
    }
    return false;
  }
};

/**
 * A student registering themselves from the website.
 *
 * No login exists yet, so nothing is taken on trust: the center is chosen on
 * the form and the registration fee is paid before this is called. The server
 * checks both before it writes a student.
 */
/* `token` is optional and only the B2B portal passes one: it lets the server
   prove which partner is registering instead of trusting a code in the form.
   The website calls this with one argument, exactly as before. */
export const registerStudentPublic = (data, token) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const response = await dispatch(postDataAPI("student/register", data, token));
    dispatch({ type: ALERT, payload: { loading: false } });
    if (response) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    if (error.response?.data?.message == "Validation errors") {
      Object.entries(error.response.data.data).map((d) => {
        dispatch({
          type: ALERT,
          payload: { error: d[1][0] },
        });
      });
    } else {
      dispatch({
        type: ALERT,
        payload: {
          error:
            error.response?.data?.message ||
            "The registration could not be saved.",
        },
      });
    }
    return false;
  }
};

/** Every approved center, for the "choose center" dropdown. */
export const getApprovedCenters = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("center/approved-list"));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

// The main-trade courses the logged-in center is approved for. Used to limit
// the course dropdown so a center only admits students into approved courses.
export const getApprovedTrades = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("centerToken");
    // NOTE: real route is under the "center" prefix group. A top-level alias
    // also exists in api.php so the older shipped bundle keeps working.
    const response = await dispatch(getDataAPI("center/approved-trades", token));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

// Membership applications from this centre's own students (for the dashboard).
export const getCenterMemberships = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("centerToken");
    const response = await dispatch(getDataAPI("center/memberships", token));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const updateStudent = (data, id) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const response = await dispatch(
      postDataAPI(`admin/student/update/${id}`, data, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: { success: "Student update successfully" },
    });
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { error: error.response.message } });
    if (error.response?.data?.message == "Validation errors") {
      Object.entries(error.response.data.data).map((d) => {
        dispatch({
          type: ALERT,
          payload: { error: d[1][0] },
        });
      });
    }
  }
};

export const getStudent = (id) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const response = await dispatch(
      getDataAPI(`admin/student/get/${id}`, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    return { ...response.data.data, isSuccess: true };
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { error: error.response.message } });
    return { isSuccess: false };
  }
};

export const getStudents = (token, page, search, date) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    console.log(search, date);
    // const token = localStorage.getItem("centerToken");
    const params = `page=${page}${search ? `&search=${search}` : ""}${
      date ? `&date=${date}` : ""
    }
  `;
    const response = await dispatch(
      getDataAPI(`center/student/list?${params}`, token)
    );
    dispatch({ type: SET_STUDENTS, payload: response.data.data });
    dispatch({ type: ALERT, payload: { loading: false } });
    return response;
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    // dispatch({ type: ALERT, payload: { error: error.response.message } });
  }
};

export const downloadStudentList =
  (token, search, date) => async (dispatch) => {
    try {
      const params = `${search ? `&search=${search}` : ""}${
        date ? `&date=${date}` : ""
      }`;
      const response = await dispatch(
        getDataAPI(`center/student/list?${params}`, token)
      );

      const dataToExport = [];
      response.data.data.forEach((ele, index) => {
        dataToExport.push({
          Sno: index + 1,
          "Student Name": ele.name,
          "Roll No": ele.roll_number,
          Course: ele.course?.name,
          Mobile: ele.student_details?.mobile,
          "Reg. Dat": ele.register_date || "",
          Fee: "Paid",
          Aadhar: ele.aadhar,
        });
      });
      exportToCSV(dataToExport, "Students");

      return response;
    } catch (error) {
      // dispatch({ type: ALERT, payload: { error: error.response.message } });
    }
  };

export const getStudentsAdmin = (page, search) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const q = `page=${page}${search ? `&search=${encodeURIComponent(search)}` : ""}`;
    const response = await dispatch(
      getDataAPI(`admin/student/list?${q}`, token)
    );
    dispatch({ type: SET_STUDENTS, payload: response.data.data });
    dispatch({ type: ALERT, payload: { loading: false } });
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { error: error.response.message } });
  }
};

// Council cancels/rejects (status 2 + reason) or re-activates (status 1) a
// student registration. Used from the admin student list.
export const rejectStudentReg = (id, status, reason) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const body = new FormData();
    body.append("status", status);
    if (reason) body.append("reason", reason);
    const response = await dispatch(
      postDataAPI(`admin/student/reject/${id}`, body, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: { success: response.data.message || "Updated" },
    });
    return true;
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: {
        error: error.response?.data?.message || "Could not update the student.",
      },
    });
    return false;
  }
};

export const uploadMarksheet = (data) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const response = await dispatch(
      postDataAPI("center/student/marksheet", data, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: { success: "Marksheet upload successfully" },
    });
    //const token = localStorage.getItem("adminToken");

    //useEffect(() => {
    dispatch(getStudents(token));
    //}, []);
    return true;
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { error: error.response.message } });
    return false;
  }
};

export const uploadCertificate = (data) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("adminToken");
    const response = await dispatch(
      postDataAPI("center/student/certificate", data, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: { success: "Certificate upload successfully" },
    });
    dispatch(getStudents(token));
    return true;
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({ type: ALERT, payload: { error: error.response.message } });
    return false;
  }
};
